const moduleKey = 'ADMIN_APPROVAL_MODULE';

export const adminApprovalTypes = {
  LOAD_REQUESTED: moduleKey + "_LOAD_REQUESTED",
  LOADED: moduleKey + "_LOADED",
  SET_TABLE_CONFIG: moduleKey + "_SET_TABLE_CONFIG",
  SET_TABLE_CONFIG_FILTER: moduleKey + "_SET_TABLE_CONFIG_FILTER",
  CHANGE_TAB: moduleKey + '_CHANGE_TAB',
  CLOSE_TAB: moduleKey + '_CLOSE_TAB',
  CREATE_TAB: moduleKey + '_CREATE_TAB',
  GET_DETAIL_REQUESTED: moduleKey + '_GET_DETAIL_REQUESTED',
  GET_DETAIL_LOADED: moduleKey + '_GET_DETAIL_LOADED',
  VERIFY_ACCOUNT: moduleKey + '_VERIFY_ACCOUNT'
};

export const adminApprovalActions = {
  loadRequested: (tableConfig) => ({ type: adminApprovalTypes.LOAD_REQUESTED, tableConfig }),
  loaded: (data) => ({ type: adminApprovalTypes.LOADED, payload: { data } }),
  setTableConfig: (key, value) => ({ type: adminApprovalTypes.SET_TABLE_CONFIG, key, value }),
  setTableConfigFilter: (key, value) => ({ type: adminApprovalTypes.SET_TABLE_CONFIG_FILTER, key, value }),
  changeTab: (key) => ({ type: adminApprovalTypes.CHANGE_TAB, key }),
  closeTab: (key) => ({ type: adminApprovalTypes.CLOSE_TAB, key }),
  createTab: (key, title) => ({ type: adminApprovalTypes.CREATE_TAB, key, title }),
  getDetail: (id, index) => ({ type: adminApprovalTypes.GET_DETAIL_REQUESTED, id, index }),
  getDetailLoaded: (data, index) => ({ type: adminApprovalTypes.GET_DETAIL_LOADED, payload: { data }, index }),
  verifyAccount: (token) => ({ type: adminApprovalTypes.VERIFY_ACCOUNT, token }),
};
